export const RESOURCE_TYPE_OPTIONS = [
  {
    value: "Article",
    label: "Article",
  },
  {
    value: "Book",
    label: "Book",
  },
  {
    value: "Booklet",
    label: "Booklet",
  },
  {
    value: "Website",
    label: "Website",
  },
  {
    value: "Brochure",
    label: "Brochure",
  },
  {
    value: "FAQ's",
    label: "FAQ's",
  },
  {
    value: "Important Information",
    label: "Important Information",
  },
  {
    value: "Information",
    label: "Information",
  },
  {
    value: "Instructions",
    label: "Instructions",
  },
  {
    value: "List",
    label: "List",
  },
  {
    value: "PDF",
    label: "PDF",
  },
  {
    value: "MUSIC",
    label: "MUSIC",
  },
  {
    value: "Podcast",
    label: "Podcast",
  },
  {
    value: "Shop Product",
    label: "Shop Product",
  },
  {
    value: "Support Group",
    label: "Support Group",
  },
  {
    value: "Video",
    label: "Video",
  },
  {
    value: "Vidscrip",
    label: "Vidscrip",
  },
  {
    value: "Other",
    label: "Other",
  },
];

// Feature flags for condition resources pages
export const CONDITION_RESOURCES_FEATURES = {
  // Show/hide status column in tables
  SHOW_STATUS_COLUMN: true,
  // Show/hide bulk select checkboxes
  SHOW_BULK_SELECT: true,
  // Show/hide status filter dropdown
  SHOW_STATUS_FILTER: true,
} as const; 